import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import english from './locales/en/translation.json';

const loadTranslationFile = async (language: string) => {
  try {
    return await import(`./locales/${language}/translation.json`);
  } catch (err) {
    return await import(`./locales/en/translation.json`);
  }
};

export const initializeLocal = async (userLanguage = 'en') => {
  const translationFile = await loadTranslationFile(userLanguage);
  // eslint-disable-next-line no-console
  console.log('i18 Translation file :', { english, translationFile });
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: english },
      [userLanguage]: { translation: translationFile.default },
    },
    // debug: true,
    lng: userLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
};
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: english },
  },
  lng: 'en',
  fallbackLng: 'en',
});
